import React from 'react';
import { RestaurantWithFoodType, SearchResultType, FoodDetailItem } from '../../../../../interfaces/types';
import { useTranslation } from 'react-i18next';
import { useUserMenuContext } from '../../../../../context/UserMenuContext';

interface SearchResultProps {
  searchResult?: SearchResultType;
  inputValue: string;
  onFoodClick: (food: FoodDetailItem, categoryId: string) => void;
}

const SearchResult: React.FC<SearchResultProps> = ({ searchResult = { restaurants: [], foods: [] }, inputValue, onFoodClick }) => {
  const { t } = useTranslation();
  const { homeMenuCategories } = useUserMenuContext();

  const filterFoodsByInput = (restaurant: RestaurantWithFoodType) => {
    return restaurant.food_details.filter((food) => food.name.toLowerCase().includes(inputValue.toLowerCase()));
  };

  // Find categoryId for a food item
  const findCategoryIdForFood = (foodId: string): string => {
    for (const category of homeMenuCategories) {
      const foundFood = category.foods.find((f) => f.id === foodId || f.food_id === foodId);
      if (foundFood) {
        return category.id;
      }
    }
    // Return first category if not found
    return homeMenuCategories.length > 0 ? homeMenuCategories[0].id : '';
  };

  // Flatten all foods from all restaurants
  const allFoods: Array<{ food: FoodDetailItem; restaurantName: string }> = [];
  searchResult.foods.forEach((restaurant) => {
    filterFoodsByInput(restaurant).forEach((food) => {
      allFoods.push({
        food,
        restaurantName: restaurant.name,
      });
    });
  });

  return (
    <div className="absolute top-[55px] max-h-[320px] overflow-auto w-full border rounded-md shadow-search no-scrollbar bg-white z-20">
      {allFoods.length > 0 ? (
        <div className="bg-white">
          {allFoods.map((item, index) => {
            const categoryId = findCategoryIdForFood(item.food.id);
            return (
              <div
                key={`${item.food.id}-${index}`}
                onClick={() => onFoodClick(item.food, categoryId)}
                className="flex flex-1 gap-4 border-b p-3 items-center hover:bg-gray-100 cursor-pointer"
              >
                <img className="h-16 w-16 rounded-lg object-cover flex-shrink-0" src={item.food.image_url} alt={item.food.name} />
                <div className="flex flex-col gap-1 flex-1 min-w-0">
                  <p className="text-black-800 text-base font-semibold leading-6 truncate">{item.food.name}</p>
                  <p className="text-sm font-medium leading-5 text-gray-500 truncate">{item.restaurantName}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="py-4 bg-white">
          <p className="text-black-800 text-base font-semibold leading-6 p-4">{t('HOME_SEARCH_RESULT')}</p>
        </div>
      )}
    </div>
  );
};

export default SearchResult;
